import $ from 'jquery';
  
const initMobileMenu = () => {
  const toggles = $('.mega-mobile__toggle');

  toggles.on('click', el => {
    const parent = $(el.currentTarget).parent();
    $(el.currentTarget).toggleClass('active');
    parent.parent().toggleClass('active');
    $(parent).siblings().toggle(250);
  })

  const megaToggle = $('.mega-mobile-toggle');

  megaToggle.on('click', el => {
    $('.mega-navigation').toggleClass('active');
    $(el.currentTarget).parent().toggleClass('active');
    $('#main-wrapper').toggle();
  })
}

(function ($, once) {
  Drupal.behaviors.forskoleforumMegaMenu = {
    attach: function (context, settings) {
      if (context !== document) {
        return;
    }
      $(once('mobilemenu', initMobileMenu()));
    },
  };
})(jQuery, once);
